import $ from 'jquery';
require('fg-frontend/third/jquery.cookie');

const DEFAULTS = {
	cookieName: 'KM_LAST_VISITED_URL_ENHANCED_RECORD',
	launcher: '.js_last_visited_url_enhancement_launcher',
	target: '.js_last_visited_url_enhancement_target'
};

const LastVisitedUrlEnhanced = function(settings) {
	this.options = $.extend(true, {}, DEFAULTS, settings);
	this.initialise_();
};

LastVisitedUrlEnhanced.prototype.initialise_ = function() {
	this.$launchers = [];
	this.bindLaunchers_();
	const self_ =  this;
	window.setTimeout(function() {
		self_.processStoredRecordIfExists_();
	}, 1500);
};

LastVisitedUrlEnhanced.prototype.bindLaunchers_ = function() {
	const self_ = this;
	$('body').on('click.lastvisitedurl', this.options.launcher, function() {
		$.cookie(self_.options.cookieName, window.location.pathname, { path: '/' });
	});
};

LastVisitedUrlEnhanced.prototype.processStoredRecordIfExists_ = function() {
	const cookieValue = $.cookie(this.options.cookieName);
	const self_ = this;

	if (cookieValue && cookieValue === window.location.pathname && $(self_.options.target).offset() && $(self_.options.target).offset().top) {
		$('html, body').animate({ scrollTop: $(self_.options.target).offset().top - 105 }, 200);
		$.cookie(this.options.cookieName, null, { path: '/' });
	}
};

module.exports = LastVisitedUrlEnhanced;


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/LastVisitedUrlEnhanced.js